<template>
  <b-modal
    id="modal-view-rejection-note"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    body-class="!p-[16px]"
  >
    <h4 class="text-black text-[16px] font-semibold mb-[16px]">
      Catatan Penolakan
    </h4>
    <b-textarea
      v-model="rejectionNote"
      class="min-h-[100px]"
      readonly
    />
    <div class="flex items-center justify-end gap-[8px] mt-[18px]">
      <b-button
        variant="outline-primary"
        size="sm"
        @click="hide"
      >
        Kembali
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalViewRejectionNote',
  data() {
    return {
      rejectionNote: '',
    }
  },
  methods: {
    show({
      note,
    }) {
      this.rejectionNote = note
      this.$bvModal.show('modal-view-rejection-note')
    },
    hide() {
      this.$bvModal.hide('modal-view-rejection-note')
    },
  },
}
</script>
